export const faqs = [
  {
    question: '精品视频精选平台的视频都是免费观看的吗？',
    answer: '是的，平台上的所有精品视频内容均免费向用户开放。我们致力于让每一位用户都能无障碍地享受高品质视听体验。部分独家内容可能需要注册账号后观看，注册也是完全免费的。',
  },
  {
    question: '视频的画质有哪些选择？',
    answer: '平台上的精品视频提供多种画质选择，包括1080P高清和4K超高清。系统会根据您的网络状况自动推荐最佳画质，您也可以手动在播放器中选择适合的画质。我们特别注重4K内容的制作和引入，确保画面细节清晰、色彩还原准确。',
  },
  {
    question: '如何找到我感兴趣的视频内容？',
    answer: '您可以通过多种方式发现感兴趣的内容：使用顶部的分类导航浏览不同类别的精品视频；在搜索框中输入关键词直接搜索；浏览首页的精选推荐和热门榜单；查看每个视频页面下方的相关推荐。我们还在不断优化个性化推荐算法，让好内容主动找到你。',
  },
  {
    question: '平台支持哪些设备观看？',
    answer: '精品视频精选平台支持所有主流设备观看，包括电脑（Windows/Mac）、平板（iPad/Android平板）和智能手机（iPhone/Android手机）。网页采用响应式设计，会根据您的设备屏幕自动调整最佳显示效果。未来我们还计划推出专门的移动App。',
  },
  {
    question: '如何向平台推荐优质视频内容？',
    answer: '我们非常欢迎用户推荐优质视频内容！您可以通过关于我们页面的联系方式，将视频链接和建议发送给我们。我们的内容团队会认真审核每一份推荐，符合平台精品标准的视频将会被收录并注明推荐来源。',
  },
  {
    question: '平台上的视频内容多久更新一次？',
    answer: '我们保持每日更新的频率，每天都会有新的精品视频内容上线。每周一和周四为固定的大更新日，届时会有多部精选视频同时发布。您可以通过订阅我们的邮件通知，第一时间获取最新上线的视频资讯。',
  },
];